import { render, staticRenderFns } from "./listDropdownV2.vue?vue&type=template&id=e2236222&"
import script from "./listDropdownV2.vue?vue&type=script&lang=js&"
export * from "./listDropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./listDropdownV2.vue?vue&type=style&index=0&id=e2236222&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2236222')) {
      api.createRecord('e2236222', component.options)
    } else {
      api.reload('e2236222', component.options)
    }
    module.hot.accept("./listDropdownV2.vue?vue&type=template&id=e2236222&", function () {
      api.rerender('e2236222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/listDropdownV2.vue"
export default component.exports